import React from 'react';
import { Route } from 'react-router-dom';
import SellerLayout from '../views/Seller/SellerLayout';
import SellerDashboard from '../views/Seller/SellerDashboard';
import SellerLeads from '../views/Seller/SellerLeads';
import SellerProposals from '../views/Seller/SellerProposals';
import SellerInvoices from '../views/Seller/SellerInvoices';
import SellerClients from '../views/Seller/SellerClients';

const sellerRoutes = (
  <Route path="/seller" element={<SellerLayout />}>
    <Route index element={<SellerDashboard />} />
    <Route path="leads" element={<SellerLeads />} />
    <Route path="proposals" element={<SellerProposals />} />
    <Route path="invoices" element={<SellerInvoices />} />
    <Route path="clients" element={<SellerClients />} />
  </Route>
);

export default sellerRoutes;
